import React, { useCallback, useState } from 'react';

import { IScheduleAreasContext, ScheduleAreasContext } from '../../hooks';

const ScheduleAreasProvider: React.FC = ({ children }) => {
  const [selectedAreas, setSelectedAreas] = useState<
    IScheduleAreasContext['selectedAreas']
  >([]);

  const toggleArea = useCallback<IScheduleAreasContext['toggleArea']>(
    item =>
      setSelectedAreas(currentAreas => {
        const isSelected = currentAreas.find(area => area.id === item.id);

        if (!isSelected) return [...currentAreas, item];

        return [...currentAreas.filter(area => area.id !== item.id)];
      }),
    [],
  );

  const selectAreas = useCallback<IScheduleAreasContext['selectAreas']>(
    items => setSelectedAreas(items),
    [],
  );

  return (
    <ScheduleAreasContext.Provider
      value={{
        selectedAreas,
        toggleArea,
        selectAreas,
      }}
    >
      {children}
    </ScheduleAreasContext.Provider>
  );
};

export default ScheduleAreasProvider;
